var get = require("object-path").get;

module.exports = {

    /**
     * The maximum width of columns in a row.
     *
     * @type  {number}
     * @public
     */
    maxColWidth: {
        portrait: {
            md: 275,
            lg: 350
        },
        landscape: {
            md: 320,
            lg: 480
        },
        square: {
            md: 275,
            lg: 350
        }
    },

    /**
     * Get the maximum width of columns in a row, based on form-factor and
     * size.
     *
     * @param   {string}  formFactor  The form-factor
     * @param   {string}  size        The size
     * @return  {number}  The maximum column width
     * @public
     */
    getMaxColWidth: function(formFactor, size) {
        return get(
            this.maxColWidth,
            formFactor + "." + size,
            this.maxColWidth.portrait.md
        );
    },

    /**
     * The minimum amount of columns to be visible at once within a row.
     *
     * @type  {number}
     * @public
     */
    minColumns: {
        portrait: {
            md: 3,
            lg: 2
        },
        landscape: {
            md: 2,
            lg: 2
        },
        square: {
            md: 3,
            lg: 2
        }
    },

    /**
     * Get the minimum amount of columns to be visible at once within a row,
     * based on form-factor and size.
     *
     * @param   {string}  formFactor  The form-factor
     * @param   {string}  size        The size
     * @return  {number}  The minimum amount of columns
     * @public
     */
    getMinColumns: function(formFactor, size) {
        return get(
            this.minColumns,
            formFactor + "." + size,
            this.minColumns.portrait.md
        );
    }

};
